<template>
  <a-layout
    v-waterMark="{ text: nickname, width: 300, height: 300 }"
    :class="['layout', device]"
  >
    <DrawerSideMenu
      v-if="!isIframe"
      :mode="sideMenuMode"
      :menus="menus"
      :theme="navTheme"
      :title="title"
      :collapsed="collapsed"
      @close="drawerClose"
      @menuSelect="menuSelect"
    />

    <a-layout
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }"
    >
      <!-- layout header -->
      <GlobalHeader
        v-if="!isIframe"
        :mode="layoutMode"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        :device="device"
        @toggle="toggle"
      >
        <HeaderNavbar
          slot="left"
          :title="title"
          :menus="menus"
          :theme="navTheme"
          :collapsed="collapsed"
          :device="device"
          @toggle="toggle"
        />
        <HeaderMenu slot="right">
          <HeaderUserMenu @logout="Logout" />
        </HeaderMenu>
      </GlobalHeader>

      <!-- layout content -->
      <a-layout-content
        :class="{
          'basic-content': true,
          'iframe-content': isIframe,
          'page-content': !isIframe,
        }"
      >
        <div class="left-basic-content">
          <MultiTab v-if="multiTab" />
          <transition name="page-transition">
            <route-view />
          </transition>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { mixin, mixinDevice } from '@/utils/mixin';
import { triggerWindowResizeEvent } from '@/utils/util';
import MultiTab from '@/components/MultiTab';
import HeaderMenu from '@/components/GlobalHeader/HeaderMenu';
import HeaderNavbar from '@/components/GlobalHeader/HeaderNavbar';
import HeaderUserMenu from '@/components/GlobalHeader/UserMenu';
import DrawerSideMenu from '@/components/Menu/DrawerSideMenu';
import GlobalHeader from '@/components/GlobalHeader/index';
import RouteView from './RouteView';

export default {
  name: 'BasicLayout',
  mixins: [mixin, mixinDevice],
  components: {
    RouteView,
    MultiTab,
    GlobalHeader,
    HeaderUserMenu,
    DrawerSideMenu,
    HeaderNavbar,
    HeaderMenu,
  },
  data() {
    return {
      isIframe: true,
      collapsed: false,
      menus: [],
    };
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: (state) => state.permission.addRouters,
      title: (state) => state.app.title,
      multiTab: (state) => state.app.multiTab,
      nickname: (state) => state.user.name,
    }),
    sideMenuMode() {
      if (this.isMobile()) {
        return 'drawer';
      }
      if (this.isSideMenu()) {
        return 'sidemenu';
      }
      return null;
    },
    contentPaddingLeft() {
      if (!this.fixSidebar || this.isMobile()) {
        return '0';
      }
      if (this.sidebarOpened) {
        return '200px';
      }
      return '80px';
    },
  },
  watch: {
    sidebarOpened(val) {
      this.collapsed = !val;
    },
    $route(val) {
      this.isIframe = val.fullPath.search('iframe=1') !== -1;
    },
  },
  created() {
    this.isIframe = window.location.href.search('iframe=1') !== -1;
    const mainMenu = this.mainMenu.find((item) => item.path === '/') || {};
    this.menus = mainMenu.children || [];
    this.collapsed = !this.sidebarOpened;
  },
  mounted() {
    const { userAgent } = navigator;
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed;
        setTimeout(() => {
          this.collapsed = !this.collapsed;
        }, 16);
      });
    }
  },
  methods: {
    ...mapActions(['setSidebar']),
    ...mapActions(['Logout']),
    toggle() {
      this.collapsed = !this.collapsed;
      this.setSidebar(!this.collapsed);
      setTimeout(() => {
        // 延迟一下，重绘页面图表
        triggerWindowResizeEvent();
      }, 300);
    },
    paddingCalc() {
      let left = '';
      if (this.sidebarOpened) {
        left = this.isDesktop() ? '200px' : '80px';
      } else {
        left = (this.isMobile() && '0') || (this.fixSidebar && '80px') || '0';
      }
      return left;
    },
    menuSelect() {
      if (!this.isDesktop()) {
        this.collapsed = false;
      }
    },
    drawerClose() {
      this.collapsed = false;
    },
  },
};
</script>

<style lang="less">
@import url("~@/components/global.less");

/*
 * The following styles are auto-applied to elements with
 * transition="page-transition" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the page transition by editing
 * these styles.
 */

.page-transition-enter {
  opacity: 0;
}

.page-transition-leave-active {
  opacity: 0;
}

.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.basic-content {
  display: flex;
  flex-flow: row;
  height: calc(100vh);
  overflow-x: hidden;
  .left-basic-content {
    flex: 1;
    display: flex;
    flex-flow: column;
    max-width: 100%;
    width: 100%;
    min-width: 100%;
  }
}

.iframe-content {
  height: calc(100vh - 64px);
}
.page-content {
  padding: 24px;
  height: calc(100vh - 64px);
}
.ant-menu-inline .ant-menu-item,
.ant-menu-inline .ant-menu-submenu-title,
.ant-menu-vertical-left .ant-menu-item,
.ant-menu-vertical-left .ant-menu-submenu-title,
.ant-menu-vertical-right .ant-menu-item,
.ant-menu-vertical-right .ant-menu-submenu-title,
.ant-menu-vertical .ant-menu-item,
.ant-menu-vertical .ant-menu-submenu-title {
  font-size: 14px;
}
.layout.ant-layout
  .top-nav-header-index
  .header-index-wide
  .header-index-left
  .logo.top-nav-header {
  padding: 0 18px;
}
.ant-layout-sider-trigger {
  background: #ffffff;
  i {
    color: #000;
  }
}
.ant-menu-submenu,
.ant-menu-item a {
  color: #000000;
}

.ant-menu-horizontal {
  // 头部导航选中样式
  .ant-menu-item-selected {
    background: #5585ed;
    a {
      color: #ffffff;
    }
  }
}

.ant-layout-sider-children {
  height: calc(100vh - 112px);
  overflow-x: hidden;
}
</style>
